//APP CONFIGURATION FILE

import appLogo from "../Assets/LoginImages/resopt_app_logo.png";
import appLogoWelcomeScreen from "../Assets/LoginImages/resopt_logo.png";
import appLogoGreyTxt from "../Assets/LoginImages/resopt_grey_txt.png";


export const APP_CONFIG = {
    APP_NAME: "RESOPT",
    TAG_LINE: "Resource Optimization Simplified",
    APP_LOGO: appLogo,
    WELCOME_SCREEN_LOGO: appLogoWelcomeScreen,
    APP_LOGO_GREY_TXT: appLogoGreyTxt,
};